import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}
  finish() {
    this.router.navigate(['dashboard']);
  }

  add() {
    this.router.navigate(['assignCourse']);
  }
}
